import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from '@/lib/utils';

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;
export const DialogTitle = DialogPrimitive.Title;
export const DialogDescription = DialogPrimitive.Description;

/** Accessible modal primitive with a focus trap, Escape and backdrop dismissal. */
export const DialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ children, className, style, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay style={{
      // Shell panels (Sidekick, sandbox, simulations) occupy layers 9000–9005.
      // A modal launched from one must cover the panel as well as the page.
      position: 'fixed', inset: 0, zIndex: 10000,
      background: 'rgba(20, 14, 30, 0.48)',
    }} />
    <DialogPrimitive.Content
      ref={ref}
      className={cn('ui-dialog-content', className)}
      style={{
        position: 'fixed', top: '50%', left: '50%', zIndex: 10001,
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 32px)', maxWidth: 640,
        maxHeight: 'calc(100dvh - 32px)', overflowY: 'auto',
        borderRadius: 24, padding: 24,
        background: 'var(--bg, #fafaf7)', color: 'var(--ink, #141318)',
        boxShadow: '0 24px 80px rgba(0,0,0,0.24), 0 0 0 1px rgba(0,0,0,0.06)',
        outline: 'none', ...style,
      }}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
DialogContent.displayName = 'DialogContent';
